// extracted by mini-css-extract-plugin
export default {"SkipToMainContent":"SkipToMainContent_SkipToMainContent__-A0i1"};